module.exports = __webpack_public_path__ + "img/asg_bg.82c603e3.jpg";